






















































































import { Component, Vue, Prop, PropSync, Watch } from 'vue-property-decorator'
import { SendMail } from '@/domain/SendMail'

@Component
export default class SendMailDialogComponent extends Vue {
  @PropSync("value", { type: Boolean , default: false, required: false })
  dialog!: boolean

  @PropSync("default", { type: SendMail, default: () => new SendMail(), required: true })
  dto!: SendMail

  @Prop({ default: false })
  isViewReportFileSendMode!: boolean

  /** バリデーション */
  invalid = false
  originalDto: SendMail = new SendMail()

  /**
   * 初期化
   */
  reset() {
    this.dto = new SendMail()
  }

  /**
   * キャンセルボタンのクリック
   */  
  onCancel() {
    this.dialog = false
    this.reset()
  }

  /**
   * 確定のクリック
   */  
  onSubmit() {
    this.dialog = false
    this.$emit("input", this.dto)
    this.reset()
  }

  @Watch("dialog")
  changeDialog() {
    if (this.dialog === true) {
      this.originalDto = this.dto.clone()
      if (this.isViewReportFileSendMode == false && this.dto.subjectReportFileOnly !== "") {
        /* 報告書のみメール送付可能 */
        this.dto.reportFileSendMode = 2
      }
    }
  }

  @Watch("dto.reportFileSendMode")
  changeAttachReportFile() {
    switch (this.dto.reportFileSendMode) {
      case 1:
        /* 報告書添付 */
        this.dto.subject = this.originalDto.subjectReportFileAttach
        this.dto.content = this.originalDto.contentReportFileAttach
        break;
      case 2:
        /* 報告書のみ */
        this.dto.subject = this.originalDto.subjectReportFileOnly
        this.dto.content = this.originalDto.contentReportFileOnly
        break;
      default:
        /* 添付しない */
        this.dto.subject = this.originalDto.subject
        this.dto.content = this.originalDto.content
        break;
    }
  }

}
